import { BufferAttribute, BufferGeometry, Camera, LineSegments, Mesh, PlaneGeometry, RawShaderMaterial, Scene } from "three";
import { line_fragments, vertex_1 } from "../shaders/shader";
import { FboBase } from "./FboBase";

export class Advection extends FboBase {
    constructor(props) {
        super({
            common: props.common,
            material: {
                vertexShader: vertex_1,
                fragmentShader: line_fragments,
                uniforms: {
                    boundarySpace: {
                        value: props.cellScale
                    },
                    px: {
                        value: props.cellScale
                    },
                    fboSize: {
                        value: props.fboSize
                    },
                    velocity: {
                        value: props.src.texture
                    },
                    dt: {
                        value: props.dt
                    },
                    isBFECC: {
                        value: true
                    }
                }
            },
            output: props.dst
        }),
        this.init()
    }
    init() {
        super.init();
        this.createBoundary();
    }
    createBoundary() {
        const bufferGeo = new BufferGeometry()
          , vecters = new Float32Array([-1, -1, 0, -1, 1, 0, -1, 1, 0, 1, 1, 0, 1, 1, 0, 1, -1, 0, 1, -1, 0, -1, -1, 0]);
        bufferGeo.setAttribute("position", new BufferAttribute(vecters,3));
        const material = new RawShaderMaterial({
            vertexShader: /*glsl */`attribute vec3 position;
                varying vec2 uv;
                uniform vec2 px;

                precision highp float;

                void main(){
                    vec3 pos = position;
                    uv = 0.5 + pos.xy * 0.5;
                    vec2 n = sign(pos.xy);
                    pos.xy = abs(pos.xy) - px * 1.0;
                    pos.xy *= n;
                    gl_Position = vec4(pos, 1.0);
                }`,
            fragmentShader: line_fragments,
            uniforms: this.uniforms
        });
        this.line = new LineSegments(bufferGeo,material);
        this.scene.add(this.line);
    }
    update({dt: e, isBounce: t, BFECC: i}) {
        this.uniforms.dt.value = e;
        this.line.visible = t;
        this.uniforms.isBFECC.value = i;
        super.update()
    }
}